import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=84927232&"
import script from "./NavHeader.vue?vue&type=script&lang=ts&"
export * from "./NavHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports